import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import styled from 'styled-components';
import { getTextColor, themeGet } from '@magalu/stereo-ui-styles';
export var Separator = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &:before {\n    content: '|';\n    margin: 0 ", "px;\n    color: ", ";\n  }\n"])), function (props) {
  return themeGet('space.1')(props);
}, function (props) {
  return getTextColor('light')(props);
});